import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CountryGrid.css';
import Country from './Country';

const SERVER_URL = process.env.SERVER_URL || 'expater-server.vercel.app';

const CountryGrid = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://${SERVER_URL}/api/get-countries`);
        setCountries(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching countries:', err);
        setError('Failed to load countries. Please try again later.');
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryClick = (country) => {
    setSelectedCountry(country);
  };

  const handleBackClick = () => {
    setSelectedCountry(null);
  };

  if (loading) return <div className="loading">Loading countries...</div>;
  if (error) return <div className="error">{error}</div>;

  if (selectedCountry) {
    return <Country 
      countryId={selectedCountry.id} 
      countryName={selectedCountry.name} 
      onBack={handleBackClick} 
    />;
  }

  return (
    <div className="country-grid-container">
      <h2>Available Countries</h2>
      <div className="country-grid">
        {countries.map(country => (
          <div 
            key={country.id} 
            className="country-card"
            onClick={() => handleCountryClick(country)}
          >
            <div className="country-flag">
              {country.code && (
                <img 
                  src={`https://flagcdn.com/w80/${country.code.toLowerCase()}.png`} 
                  alt={`${country.name} flag`}
                />
              )}
            </div>
            <h3>{country.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountryGrid;